import { jsx as _jsx } from "react/jsx-runtime";
import Skeleton from 'react-loading-skeleton';
import useStyles from './SkeletonPageHeader.styles';
const SkeletonPageHeader = () => {
    const { classes } = useStyles();
    return (_jsx("div", { className: classes.pageHeaderSkeletonCard, children: _jsx(Skeleton, { width: `100%`, height: `100%` }) }));
};
export default SkeletonPageHeader;
